import React from 'react'
import { Subscribe } from 'unstated'
import CalendarStore from '../Store/CalendarStore'
import Day from './Day'
import { generateLayerData, getSlotsForTheDay } from '../Helpers/Calendar'

const SlotLayers = () => (
  <Subscribe to={[CalendarStore]}>
    {(calendarStore) => {
      const { state, isSlotAvailable } = calendarStore

      return (
        <div className='slotLayers'>
          {generateLayerData(calendarStore).map(({ slots, ...slotInfo }, i) => {
            return (
              <div
                className={'slotLayer ' + slotInfo.tag.marked}
                key={'slotLayer' + i}
              >
                {state.currentWeek.map((day, i) => (
                  <Day
                    key={'day' + i}
                    day={i}
                    slots={
                      getSlotsForTheDay(
                        slots,
                        slotInfo.slotType,
                        state.currentWeek,
                        i,
                      ) || []
                    }
                    {...slotInfo}
                    courseInfo={state.courseInfo}
                    isSlotAvailable={isSlotAvailable}
                    isHalf={state.slotDuration === 30}
                    isToday={
                      day.toLocaleDateString() ===
                      new Date().toLocaleDateString()
                    }
                  />
                ))}
              </div>
            )
          })}
        </div>
      )
    }}
  </Subscribe>
)

export default SlotLayers
